//this is the base environment - the 2 platforms (rival and gamingpodium ) are based on this

export const environment = {

  production: true, //already published + needs optimization in angular.json

  platform: "unknown", //=> isRivalCasino() in configService

  // --- Features & Flags ---
  // isAffiliated: true, //to have landings - all brands so we can remove
  hasMinReg: false,
  hasComplaintsForm: false,
  isLandingsOnly: false, //used in landings for navigate to registration - could be refactored to landingService
  ctaLinks: { //for only-landing brands for navigating to external websites from landings with tracker
    home: undefined,
    sport: undefined,
    casino: undefined
  },

  splitTestEnabled: false, //to test things on some part of the users: ex. new cashier

  // --- Core Identification & Branding ---
  rivalName: "testbrand", //shortName used for assets(ex.landings - could be done better) and rival API URLs/settings
  casinoId: 0, //called merchant_id on GP brands => for API URLs/settings
  assetsPath: undefined, //used for branded assets in components(because rivalName can be different from our brandName)
  prettyName: "TestBrand", //public name, as we call the brand
  //SEO
  GA_TRACKING: "",
  metaDescription: "Play premier gaming at Online Casino with slots (slot machine), live dealers, bingo, jackpot games. Real deposit bonuses, VIP loyalty program, secure play, trusted affiliates and fair gaming for cash wins and big money prizes!",
  logoName: "logo.png",
  logoAltText: "Test logo, made for testing lobbyless sites.",

  // --- Support & Communication & Chat ---
  contactEmail: "support@test.casino",
  docsEmail: "finance@test.casino",
  //legal & licence for Terms and FAQ
  legalData: {
    withdrawalTime: 18, //null = should be 5-18
    minDepositAmount: 5, //not used currently (new min dep will be: 10 eur/usd/gbp, 20 aud/nzd/cad, 200 ZAR) 5mar 2025
    affTerms: false
  },
  license: undefined,
  licenseNo: "",
  minAgeAtReg: 18,   //minimal age at registration - as default

  chatSystem: 'other', // see chatSystem: in configService, chatserver in chatService (default chat server on Rival: 'chat-v3.casinocontroller.com')
  rivalChatGroupName: "Test Brand", //for rival chat (will be overwritten for other brands)
  //for flipAPI (chatwoot):
  chatwoot_websiteToken: undefined,
  chatwoot_userIdentifier: undefined,
  backoffice_url: undefined, //for chatwoot --> in GP and rival environments + configservice


  // --- Data ---
  apiUrl: undefined, //defined in config.service
  cdnUrl: `https://cdn.0x6e.com/platforms`,  //https://cdn.0x6e.com/platforms/${platform}.json

  publicPromotions: []

};


